import "bootstrap";
import './styles/style.scss'
import './styles/responsive.scss'

import "./images/fb.png";
import "./images/twitter.png";
import "./images/linkedin.png";
import "./images/instagram.png";

import { pd_info } from './data/product_information';
import { setupHeader } from "./header";
import { go_to_site } from "./libs/utils";
import {createDiv, createImg, createDOMElement} from './libs/elementFactory';



var all_listing_wrapper = document.getElementById("all_ig_listing");

function generate_ig_link_card(pd_details) {
    let img_url = pd_details["Catalog Image Link"]+"01.jpg";
    let product_title = pd_details["Sku Name"];

    let card = createDiv("", ["card"]);
    let img = createImg("", img_url, ["ard-img-top"], [{"key":"alt", "value":"Card image cap"}]);
    card.appendChild(img);
    let card_body = createDiv("", ["card-body"]);
    let card_title = createDOMElement("h5", "", ["card-title"],[]);
    card_title.innerHTML = product_title;
    card_body.appendChild(card_title);
    
    card.appendChild(card_body);

    card.onclick =  function() {
        let link = pd_details["Meesho Link"];
        go_to_site(link, false);
    }
    
    return card;
}

function load_products() {
    let products = pd_info["products"];
    let pids = Object.keys(products);

    pids.forEach(element => {
        let card = generate_ig_link_card(products[element]);    
        all_listing_wrapper.appendChild(card);
    });
}

function initUi() {
    setupHeader();
    load_products();
}

window.onload = function() {
    initUi();
}